import publicIp from 'public-ip';

export const fetchIp = async() => {
  let userIp = undefined;
  try {
    userIp = await publicIp.v4(); // Obtiene la IP pública en formato IPv4
  } catch (error) {
    console.error('Error fetching IP:', error); // eslint-disable-line no-console
  }

  return userIp;
};